import Fuse from 'fuse.js';
import sortBy from 'lodash/sortBy';

export const createTreeSearch = (trees) => {

  const sortedTrees = sortBy(trees, ['number', 'side']);

  const options = {
    keys: ['number', 'plaque', 'fullName'],
    threshold: 0.2,
    tokenize: true,
  };

  return new Fuse(sortedTrees, options);

};